var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.8042 14.477C1.8042 14.477 1.9462 16.215 1.9792 16.763C2.0232 17.498 2.3072 18.319 2.7812 18.889C3.4502 19.697 4.2382 19.982 5.2902 19.984C6.5272 19.986 15.5222 19.986 16.7592 19.984C17.8112 19.982 18.5992 19.697 19.2682 18.889C19.7422 18.319 20.0262 17.498 20.0712 16.763C20.1032 16.215 20.2452 14.477 20.2452 14.477M7.4961 4.32949V3.95849C7.4961 2.73849 8.4841 1.75049 9.7041 1.75049H12.2861C13.5051 1.75049 14.4941 2.73849 14.4941 3.95849L14.4951 4.32949M10.9951 15.6782V14.3842M1.75 7.38909V10.8561C3.668 12.1211 5.966 13.0071 8.488 13.3581C8.79 12.2571 9.783 11.4501 10.99 11.4501C12.178 11.4501 13.191 12.2571 13.473 13.3681C16.005 13.0171 18.312 12.1311 20.24 10.8561V7.38909C20.24 5.69509 18.877 4.33109 17.183 4.33109H4.817C3.123 4.33109 1.75 5.69509 1.75 7.38909Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.e0be1efa.svg";
export { ForwardRef as ReactComponent };